/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchOperationV2GoalkeeperTeamState } from './MatchOperationV2GoalkeeperTeamState';
import {
    MatchOperationV2GoalkeeperTeamStateFromJSON,
    MatchOperationV2GoalkeeperTeamStateFromJSONTyped,
    MatchOperationV2GoalkeeperTeamStateToJSON,
    MatchOperationV2GoalkeeperTeamStateToJSONTyped,
} from './MatchOperationV2GoalkeeperTeamState';

/**
 * 
 * @export
 * @interface MatchOperationV2GoalkeeperState
 */
export interface MatchOperationV2GoalkeeperState {
    /**
     * 
     * @type {MatchOperationV2GoalkeeperTeamState}
     * @memberof MatchOperationV2GoalkeeperState
     */
    teamA: MatchOperationV2GoalkeeperTeamState;
    /**
     * 
     * @type {MatchOperationV2GoalkeeperTeamState}
     * @memberof MatchOperationV2GoalkeeperState
     */
    teamB: MatchOperationV2GoalkeeperTeamState;
}

/**
 * Check if a given object implements the MatchOperationV2GoalkeeperState interface.
 */
export function instanceOfMatchOperationV2GoalkeeperState(value: object): value is MatchOperationV2GoalkeeperState {
    if (!('teamA' in value) || value['teamA'] === undefined) return false;
    if (!('teamB' in value) || value['teamB'] === undefined) return false;
    return true;
}

export function MatchOperationV2GoalkeeperStateFromJSON(json: any): MatchOperationV2GoalkeeperState {
    return MatchOperationV2GoalkeeperStateFromJSONTyped(json, false);
}

export function MatchOperationV2GoalkeeperStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationV2GoalkeeperState {
    if (json == null) {
        return json;
    }
    return {
        
        'teamA': MatchOperationV2GoalkeeperTeamStateFromJSON(json['teamA']),
        'teamB': MatchOperationV2GoalkeeperTeamStateFromJSON(json['teamB']),
    };
}

export function MatchOperationV2GoalkeeperStateToJSON(json: any): MatchOperationV2GoalkeeperState {
    return MatchOperationV2GoalkeeperStateToJSONTyped(json, false);
}

export function MatchOperationV2GoalkeeperStateToJSONTyped(value?: MatchOperationV2GoalkeeperState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamA': MatchOperationV2GoalkeeperTeamStateToJSON(value['teamA']),
        'teamB': MatchOperationV2GoalkeeperTeamStateToJSON(value['teamB']),
    };
}

